import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Config from '../server.json';

const Ordinances = () => {
  const [ordinances, setOrdinances] = useState([]);
  const [tags, setTags] = useState([]); 
  const [tagInput, setTagInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingPercentage, setLoadingPercentage] = useState(0);  
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const ordinancesPerPage = 6;

  
const fetchOrdinances = async () => {
  setLoading(true);
  setLoadingPercentage(0);  

  try {
    const url =
      `${Config.ORDINANCES_API_URL}?page=${page}&order=desc` +
      (tags.length > 0 ? `&search=${encodeURIComponent(tags.join(' '))}` : '');

     let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setLoadingPercentage(progress);
      if (progress >= 100) clearInterval(interval);
    }, 200);

    const res = await fetch(url);
    const data = await res.json();
    const list = Array.isArray(data.ordinances) ? data.ordinances : [];

    setHasMore(list.length >= ordinancesPerPage);
    setOrdinances(list);
  } catch (err) {
    console.error('Fetch error:', err);
  } finally {
    setLoading(false);
    setLoadingPercentage(100);   
  }
};

   useEffect(() => {
    fetchOrdinances();
  }, [page]); 

   const handleSearch = () => {
    setPage(1);   
    fetchOrdinances();  
  };

  const handleAddTag = () => {
    if (tagInput.trim() !== '' && !tags.includes(tagInput.trim())) {
      setTags(prevTags => [...prevTags, tagInput.trim()]);
    }
    setTagInput('');
  };

  const handleRemoveTag = (tag) => {
    setTags(prevTags => prevTags.filter(t => t !== tag));
  };

  const loadNext = () => {
    if (hasMore) {
      setPage(prev => prev + 1);
    }
  };

  const loadPrevious = () => {
    if (page > 1) {
      setPage(prev => prev - 1);
    }
  };

 

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-6 text-center">Ordinances</h1>

         <div className="mb-4 flex flex-col sm:flex-row items-center gap-2">
          <input
            type="text"
            placeholder="Enter an ordinance keyword"
            value={tagInput}
            onChange={e => setTagInput(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleAddTag()}
            className="flex-1 border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            onClick={handleAddTag}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Add  Keyword
          </button>
        </div>

         <div className="mb-4">
          {tags.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {tags.map((tag, index) => (
                <span
                  key={index}
                  className="inline-flex items-center bg-blue-200 text-blue-800 rounded-full px-3 py-1 text-sm"
                >
                  {tag}
                  <button
                    onClick={() => handleRemoveTag(tag)}
                    className="ml-2 text-red-600 hover:text-red-800"
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          )}
        </div>

         <div className="mb-6">
          <button
            onClick={handleSearch}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-green-600 transition-colors"
          >
            Search
          </button>
        </div>

        {loading && (
          <div className="text-center mb-4">
            <p className="text-gray-500">Loading… {loadingPercentage}%</p>
            <div className="w-full bg-gray-300 rounded-full h-2">
              <div
                className="bg-blue-600 h-2 rounded-full"
                style={{ width: `${loadingPercentage}%` }}
              />
            </div>
          </div>
        )}

        <div className="space-y-6">
          {ordinances.length > 0 ? (
            ordinances.map(o => (
              <Link
                key={o.idOrdinances}
                to={`/ordinances/${encodeURIComponent(o.OrdNo)}`}
                className="block bg-white p-6 rounded-lg shadow hover:bg-blue-100 transition-colors"
              >
                <p className="text-sm text-gray-500 mb-1">
                  Date Enacted: {o.DateAdopted}
                </p>
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  {o.OrdNo}
                </h2>
                <p className="text-gray-700 mb-4">{o.Title}</p>
                {o.Link && (
                  <span className="inline-block text-blue-600 hover:underline">
                    View Document →
                  </span>
                )}
              </Link>
            ))
          ) : (
            <p className="text-center text-gray-500">No ordinances found.</p>
          )}
        </div>

        <div className="mt-6 flex justify-between items-center">
      
        <div className="w-full flex justify-between items-center space-x-4">
  <button
    className="w-full max-w-[150px] text-blue-600 hover:text-green-600 transition-colors"
    onClick={loadPrevious}
    disabled={page === 1 || loading}
  >
    ← New Entries
  </button>

  <button
    className="w-full max-w-[150px] text-blue-600 hover:text-green-600 transition-colors"
    onClick={loadNext}
    disabled={!hasMore || loading}
  >
    Older Entries →
  </button>
</div>


        </div>
      </div>
    </div>
  );
};

export default Ordinances;
